/**
 * @file index.tsx
 * @module app/modules/finance
 * @description Defines lazy-loaded routes and page metadata for finance payments and refunds.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { lazy } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
const PaymentDashboard = lazy(() => import('./dashboard/payment-dashboard'));
const PaymentsToSellers = lazy(() => import('./payments/payments-to-sellers'));
const SellerFinanceDetails = lazy(
  () => import('./payments/seller-finance-details')
);
const MakePayment = lazy(() => import('./payments/make-payment'));
const PaymentCompleted = lazy(() => import('./payments/payment-completed'));
const RefundsToCustomers = lazy(() => import('./refunds/refunds-to-customers'));
const CustomerFinanceDetails = lazy(
  () => import('./refunds/customer-finance-details')
);
const paymentBreadCrumbs: Array<PageLink> = [
  {
    title: "Payments",
    path: "/payments",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const PaymentsIndex = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            index
            element={<Navigate to="/payments" />}
          />
          {/* Payments to sellers */}
          <Route
            path="payment-dashboard"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Payment Dashboard
                </PageTitle>
                <PaymentDashboard />
              </>
            }
          />
          <Route
            path="payments-to-sellers"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Payments to Sellers
                </PageTitle>
                <PaymentsToSellers />
              </>
            }
          />
          <Route
            path="payments-to-sellers/seller-finance-details"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Seller Finance Details
                </PageTitle>
                <SellerFinanceDetails />
              </>
            }
          />
          <Route
            path="/payments-to-sellers/seller-finance-details/make-payment"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Make Payment
                </PageTitle>
                <MakePayment />
              </>
            }
          />
          <Route
            path="/payments-to-sellers/seller-finance-details/payment-completed"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Payment Completed
                </PageTitle>
                <PaymentCompleted />
              </>
            }
          />
          {/* Refunds to customers */}
          <Route
            path="refunds-to-customers"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Refunds to Customers
                </PageTitle>
                <RefundsToCustomers />
              </>
            }
          />
          <Route
            path="refunds-to-customers/customer-finance-details"
            element={
              <>
                <PageTitle breadcrumbs={paymentBreadCrumbs}>
                  Customer Finance Details
                </PageTitle>
                <CustomerFinanceDetails />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  );
};
export default PaymentsIndex;
